import React from 'react'
import Developed from './Developed'
import { Divider } from '@mui/material'
import CompanyName from './CompanyName';

const today = new Date();

const Footer = () => {
    return (
        <div className='mx-16'>

            <div className='my-5'><Divider style={{ backgroundColor: '#0F0F0F' }} /></div>
            <div className=''>&copy; {today.getFullYear()} - <CompanyName /></div>
            <div className='print:invisible'><Developed /></div>
        </div>
    )
}

export default Footer